module.exports = __webpack_public_path__ + "assets/img/free_13.e1474639.png";